import request from '@/utils/request'

// 分页查询回收门店
export function pageRecycleStore(data) {
  return request({
    url: '/biz/admin/recycle/store/page',
    method: 'post',
    data: data
  })
}

// 回收门店详情
export function getRecycleStore(data) {
  return request({
    url: '/biz/admin/recycle/store/detail',
    method: 'post',
    data: data
  })
}

// 新增回收门店
export function addRecycleStore(data) {
  return request({
    url: '/biz/admin/recycle/store/add',
    method: 'post',
    data: data
  })
}

// 修改回收门店
export function updateRecycleStore(data) {
  return request({
    url: '/biz/admin/recycle/store/edit',
    method: 'post',
    data: data
  })
}

// 删除回收门店
export function delRecycleStore(data) {
  return request({
    url: '/biz/admin/recycle/store/delete',
    method: 'post',
    data: data
  })
}
